import CupsListTable from './CupsListTable';

export default CupsListTable;
